import React from 'react';
import { TrendingUp } from 'lucide-react';
import { metrics } from '../mock';

const ExperienceSection = () => {
  return (
    <section className="py-24 bg-gradient-to-br from-[#00B4D8] to-[#0077BE] relative overflow-hidden">
      {/* Animated Background Elements */}
      <div className="absolute top-0 left-1/4 w-96 h-96 bg-white/5 rounded-full blur-3xl animate-pulse"></div>
      <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-white/5 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold text-white mb-6">
            Experience & Track Record
          </h2>
          <p className="text-xl text-white/80 max-w-3xl mx-auto">
            Proven excellence in specialized student transportation
          </p>
        </div>

        {/* Metrics Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {metrics.map((metric, index) => (
            <div 
              key={index}
              className="text-center p-8 rounded-3xl backdrop-blur-xl bg-white/10 border border-white/20 hover:bg-white/20 transition-all duration-300 hover:scale-105 group"
            >
              <div className="mb-4">
                <TrendingUp className="w-12 h-12 text-white mx-auto group-hover:scale-110 transition-transform duration-300" />
              </div>
              <div className="text-5xl font-bold text-white mb-2">
                {metric.value}
              </div>
              <div className="text-white/80 font-semibold">
                {metric.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ExperienceSection;
